// extracted by mini-css-extract-plugin
export default {"container":"navlink_container__3fK6D","text":"navlink_text__oJitd"};